var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileTrendingIinactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2943 10.6861H24.9898L27.5225 16.3118H16.827L14.2943 10.6861Z",
    fill: "#FFC000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2943 10.6861H24.9898L27.5225 16.3118H16.827L14.2943 10.6861Z",
    stroke: "#4E3D0F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2282 10.6861H3.53275L1 16.3118H11.6955L14.2282 10.6861Z",
    fill: "#FFC000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2282 10.6861H3.53275L1 16.3118H11.6955L14.2282 10.6861Z",
    stroke: "#756020",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22824 16.3027H7.61412H11.7282L14.2282 10.6861L16.7282 16.3027H19.2282H24.2282V27.5121H4.22824V16.3027Z",
    fill: "url(#paint0_linear)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22824 16.3027H7.61412H11.7282L14.2282 10.6861L16.7282 16.3027H19.2282H24.2282V27.5121H4.22824V16.3027Z",
    stroke: "#4E3D0F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2943 10.6861V27.5121",
    stroke: "#4E3D0F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3836 1C15.0528 1.00142 14.5089 2.08026 14.4682 2.12767C14.3142 2.30523 14.1094 2.34167 13.9015 2.12366C13.1868 0.858355 11.4676 0.617623 10.4391 1.6537C10.0242 2.07167 9.79603 2.62638 9.79661 3.21579C9.79913 5.68677 11.9651 7.63778 14.0929 8.64812C14.1247 8.6632 14.1591 8.67079 14.1934 8.67079C14.2279 8.67079 14.2624 8.66315 14.2943 8.64791C16.4408 7.62328 18.5822 5.6662 18.5798 3.20672C18.5785 1.98998 17.5934 1 16.3836 1Z",
    fill: "url(#paint1_linear)",
    stroke: "#4E3D0F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 13.7943,
    y: 10.1861,
    width: 14.2282,
    height: 6.62573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.933333 0 0 0 0 0.717647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 0.5,
    y: 10.1861,
    width: 14.2282,
    height: 6.62573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.933333 0 0 0 0 0.717647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i",
    x: 3.72824,
    y: 10.1861,
    width: 21,
    height: 17.826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.933333 0 0 0 0 0.717647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.22824,
    y1: 10.6861,
    x2: 4.22824,
    y2: 27.5121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.79661,
    y1: 1,
    x2: 9.79661,
    y2: 8.67079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F990A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0576A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTrendingIinactive);
export default __webpack_public_path__ + "static/media/MobileTrendingIinactive.ca39b0c2.svg";
export { ForwardRef as ReactComponent };